import styles from "./Standing.module.scss";

interface Props {
  /* Let's describe props here */
}

export const Standing: React.FC<Props> = () => {
  return <div className={styles.root}>a Standing component</div>;
};
